import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SetPasswordFormBuilder } from './set-password-form.builder';
import { IFormFieldErrorMessages } from 'i2g-ng-ui';
import { ITrackingAction, ITrackingObject } from 'i2g-ng-tracking';

export interface ISetPasswordInfo {
  password: string;
  confirm_password: string;
}

@Component({
  selector: 'app-set-password-form',
  templateUrl: './set-password-form.component.html',
  styleUrls: ['./set-password-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [SetPasswordFormBuilder],
})
export class SetPasswordFormComponent implements OnInit, OnChanges {
  @Input() disabled = false;
  @Input() trackingObject: ITrackingObject;
  @Input() trackingAction: ITrackingAction;

  @Output()
  buttonSubmit: EventEmitter<ISetPasswordInfo> = new EventEmitter<ISetPasswordInfo>();

  formKeys: any;
  form: FormGroup;
  passwordErrorMessage: IFormFieldErrorMessages;

  constructor(private _forgotPasswordFormBuilder: SetPasswordFormBuilder) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.disabled && this.form) {
      if (this.disabled) {
        this.form.disable();
      } else {
        this.form.enable();
      }
    }
  }

  ngOnInit() {
    this.formKeys = this._forgotPasswordFormBuilder.FORM_KEYS;
    this.form = this._forgotPasswordFormBuilder.buildForm();
    this.passwordErrorMessage = this._forgotPasswordFormBuilder.buildPasswordErrorMessages();
  }

  get password() {
    return this.form.get(this.formKeys.PASSWORD);
  }

  get confirmPassword() {
    return this.form.get(this.formKeys.CONFIRM_PASSWORD);
  }

  submit() {
    if (this.form.invalid) {
      this.password.markAsDirty();
      this.confirmPassword.markAsDirty();
      return;
    }

    const password = this.password.value;
    const confirm_password = this.confirmPassword.value;
    this.buttonSubmit.emit({
      password,
      confirm_password,
    });
  }
}
